exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".car_in_city .weui_cells:after{border:none}.car_city .all_in .weui_cells_checkbox .weui_cell{padding:0}.car_city .all_in .weui_cells_checkbox:after,.car_city .all_in .weui_cells_checkbox:before{border:none}", ""]);

// exports
